import React, { Component } from 'react';
import { Stage, Group, Layer, Circle, Line, Rect, Text } from 'react-konva';
import './App.css';
import moment from 'moment';
import { CopyToClipboard } from 'react-copy-to-clipboard' ;
import Spinner from './components/Spinner';
import QRCode from 'qrcode.react';
import SmoothScroll from 'smooth-scroll';

const PlotHeight = 250;
const StageHeight = 520;
const PlotPadding = 20;
const Intensity = "HapticIntensity";
const Sharpness = "HapticSharpness";
const Continuous = "HapticContinuous";
const Transient = "HapticTransient";
const TransientWidth = 8;

const BackendBasePath = "https://ahap.fancypixel.it"

const State = {
  NEW: 'NEW',
  EDIT: 'EDIT',
  DELETE: 'DELETE'
}

class App extends Component {
  state = {
    plotState: State.NEW,
    showTransient: true,
    showContinuous: true,
    selected: null,
    selectedType: null, // Intensity | Sharpness
    selectedDirection: null, // 'left | 'right'
    permalink: null,
    lastUpdate: null,
    saving: false,
    copy: null,
    isModalOpen: false,
    isLoadModalOpen: false,
    isCodeViewVisibile: false,
    continuousSelection: null,
    timeInterval: null,
    loadError: null,
    loadFile: '',
    screen: {
      width: window.innerWidth,
      height: window.innerHeight
    },
    mouse: {
      x: 0, y: 0
    },
    duration: 1.0,
    data: {
      Version: 1.0,
      Pattern: []
    }
  }

  componentDidMount() {
    window.addEventListener("resize", this.onResize);

    if (window.location.pathname !== '/') {
      this.scrollToContent();
      const hash = window.location.pathname.split('/')[1];
      if (hash) {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', `${BackendBasePath}/${hash}.json`, true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onreadystatechange = (event) => {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              try {
                const res = JSON.parse(`${xhr.responseText}`);
                this.setState({ permalink: hash, data: res, fetching: false });
              } catch (e) {
                console.log(e);
              }
            } else {
              this.setState({ error: true, fetching: false });
              window.history.replaceState({}, 'AHAB', '/');
            }
          }
        };
        this.setState({ fetching: true });
        xhr.send();
      }
    }

    if (!this.state.timeInterval) {
      this.setState({
        timeInterval: setInterval(() => { this.setState({}); }, 1000 * 60)
      });
    }
  }

  updateTimeout = null;

  updateHaptic = () => {
    if (this.state.permalink) {
      clearInterval(this.updateTimeout);
      this.updateTimeout = setTimeout(() => {
        this.onSave(false);
      }, 1000);
    }
  }

  onMouseMove = (event) => {
    const container = this.stage.content.getBoundingClientRect();
    const x = event.evt.clientX - container.left;
    const y = event.evt.clientY - container.top;

    if (this.state.plotState === State.EDIT && this.state.selected !== null) {
      const plotXOffset = 15;
      const width = this.state.screen.width - (PlotPadding * 2) - (plotXOffset * 2);
      const pattern = [...this.state.data.Pattern];
      const plotYOffset = this.state.selectedType === Sharpness ? PlotHeight : 0;

      let value = -(y - plotYOffset - (PlotHeight - (PlotPadding * 2)) - PlotPadding);
      value = Math.max(Math.min(value / (PlotHeight - PlotPadding * 2), 1), 0);

      let time = Math.max(Math.min(((x - PlotPadding - TransientWidth * 2 + plotXOffset) / width * this.state.duration), this.state.duration), 0);

      if (pattern[this.state.selected].Event.EventType === Transient) {
        pattern[this.state.selected].Event.Time = time;
      }

      if (pattern[this.state.selected].Event.EventType === Continuous) {
        if (this.state.selectedDirection === 'left') {
          let duration = pattern[this.state.selected].Event.EventDuration + (pattern[this.state.selected].Event.Time - time);
          if (duration < 0.01) { return; }
          pattern[this.state.selected].Event.EventDuration = duration;
          pattern[this.state.selected].Event.Time = time;
        } else {
          let duration = time - pattern[this.state.selected].Event.Time;
          if (duration < 0.01) { return; }
          pattern[this.state.selected].Event.EventDuration = duration;
        }
      }

      pattern[this.state.selected].Event.EventParameters = pattern[this.state.selected].Event.EventParameters.map(e => e.ParameterID === this.state.selectedType ? { ParameterID: e.ParameterID, ParameterValue: value } : e);

      this.setState({ ...this.state, mouse: { x, y }, data: { Version: 1.0, Pattern: pattern } });
    } else {
      this.setState({ ...this.state, mouse: { x, y } });
    }
  }

  onResize = (event) => {
    this.setState({ screen: { width: window.innerWidth, height: window.innerHeight } });
  }

  onDurationChange = (event) => {
    this.setState({ duration: event.target.value });
  }

  onNewTransient = ({ value, time }) => {
    this.setState({ ...this.state, data: {
      Version: this.state.data.Version,
      Pattern: [
        ...this.state.data.Pattern,
        {
          Event: {
            Time: time * this.state.duration,
            EventType: Transient,
            EventParameters: [
              { ParameterID: Intensity, ParameterValue: value },
              { ParameterID: Sharpness, ParameterValue: value }
            ]
          }
        }
      ]
     },
     continuousSelection: null
    });
  }

  onMouseDown = ({ value, time, index, type, direction }) => {
    if (this.state.plotState === State.NEW) {
      this.setState({ continuousSelection: { time, show: false, value } });
      this.updateHaptic();
    } else {
      this.setState({ selected: index, selectedType: type, selectedDirection: direction });
    }
  }

  onMouseUp = ({ value, time }) => {
    if (this.state.continuousSelection && this.state.continuousSelection.show) {
      this.setState({ ...this.state, data: {
          Version: this.state.data.Version,
          Pattern: [
            ...this.state.data.Pattern,
            {
              Event: {
                Time: this.state.continuousSelection.time * this.state.duration,
                EventType: Continuous,
                EventDuration: this.state.continuousSelection.duration * this.state.duration,
                EventParameters: [
                  { ParameterID: Intensity, ParameterValue: value },
                  { ParameterID: Sharpness, ParameterValue: value }
                ]
              }
            }
          ]
        },
        continuousSelection: null
      });
    }
    this.updateHaptic();
  }

  onNewItemMove = ({ value, time }) => {
    if (this.state.continuousSelection && this.state.continuousSelection.time) {
      this.setState({ continuousSelection: { ...this.state.continuousSelection, duration: Math.max(0.005, time - this.state.continuousSelection.time), value, show: true } });
    }
  }

  onMouseLeave = ({ value, time }) => {
    this.setState({ continuousSelection: null });
  }

  onDeleteEvent = (index) => {
    const { data } = this.state;
    const pattern = [...data.Pattern];
    pattern.splice(index, 1);
    this.setState({ ...this.state, data: {
        Pattern: pattern
      }
    });
    this.updateHaptic();
  }

  onSave = (showModal: boolean) => {
    const xhr = new XMLHttpRequest();
    xhr.open(this.state.permalink ? 'PATCH' : 'POST', `${BackendBasePath}/files${this.state.permalink ? `/${this.state.permalink}` : ''}`, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onreadystatechange = (event) => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          if (!this.state.permalink) {
            try {
              const res = JSON.parse(`${xhr.responseText}`);
              this.setState({ permalink: res.permalink, saving: false, lastUpdate: moment() });
              window.history.replaceState({}, 'AHAP', res.permalink);
              if (showModal) {
                this.toggleModal(true);
              }
            } catch (e) {
              console.log(e);
            }
          } else {
            this.setState({ saving: false, lastUpdate: moment() });
          }
        } else {
          this.setState({ error: true, saving: false });
        }
      }
    };
    const content = JSON.stringify(this.state.data);
    this.setState({ saving: true });
    xhr.send(JSON.stringify({
      file: {
        content
      }
    }));
  }

  hintForCurrentState = () => {
    switch (this.state.plotState) {
      case State.NEW:
        return <span>Click to add a transient event, click and drag for a continuous one.</span>;
      case State.EDIT:
        return <span>Drag up on an item to change the intensity or sharpness. Drag left and right to change its position.</span>;
      case State.DELETE:
        return <span>Click on the item to delete.</span>;
      default: break;
    }
    return null;
  }

  toggleModal = (isModalOpen: boolean) => {
    this.setState({ isModalOpen, isCodeViewVisibile: false });
  }

  toggleCodeView = (isCodeViewVisibile: boolean) => {
    this.setState({ isModalOpen: false, isCodeViewVisibile });
  }

  toggleLoadView = (isLoadModalOpen: boolean) => {
    this.setState({ isModalOpen: false, isCodeViewVisibile: false, isLoadModalOpen });
  }

  onCopy = (copy) => {
    this.setState({ copy });
    setTimeout(() => { this.setState({ copy: null }); }, 4000);
  }

  scrollToContent = () => {
    const scroll = new SmoothScroll('a[href*="#"]', { speed: 1500, easing: 'easeInOutCubic', updateURL: false });
    scroll.animateScroll(document.querySelector('#content'));
  }

  onLoadTextChange = (el) => {
    this.setState({ loadFile: el.target.value });
  }

  onLoadConfirm = () => {
    try {
      const loadFile = JSON.parse(this.state.loadFile);
      if (loadFile && loadFile.Version && loadFile.Pattern) {
        this.setState({ data: loadFile, loadFile: '', isLoadModalOpen: false, loadError: null });
      } else {
        this.setState({ loadError: 'The AHAP format is not valid' });
      }
    } catch {
      this.setState({ loadError: 'The AHAP format is not valid' });
    }
  }

  render() {
    const { mouse, screen, data, duration, plotState } = this.state;

    const outputCodeView = (
      <div className="App-output" style={{ right: this.state.isCodeViewVisibile ? '0' : '-35rem' }} >
        <div className="App-title">
          <h2>AHAP Output</h2>
          <p>Here is your AHAP file.</p>
          <i className="icon-round-clear App-output-close-icon"onClick={this.toggleCodeView.bind(null, false)} />
        </div>
        <textarea value={JSON.stringify(data, null, 2)} onChange={() => {}} readOnly></textarea>
        <div className="App-output-copy-button-container">
          <span className="copy-success-message" style={{ opacity: this.state.copy === "output" ? '1.0' : '0' }}><i className="icon-round-check-circle-outline" style={{ marginRight: '0.3rem' }} />Copied!</span>
          <CopyToClipboard text={JSON.stringify(data, null, 2)} onCopy={this.onCopy.bind(null, "output")}>
            <span className="copy-button"><i className="icon-copy" style={{ marginRight: '.3rem', fontSize: '.7rem' }} />Copy</span>
          </CopyToClipboard>
        </div>
      </div>
    );

    const loadView = (
      <div className="App-modal" style={{ display: this.state.isLoadModalOpen ? 'initial' : 'none' }} >
        <div className="App-title" style={{ paddingBottom: '1rem' }}>
          <h2>Load from JSON</h2>
          <p>Load a previous AHAP file:</p>

          <i className="icon-round-clear App-output-close-icon"onClick={this.toggleLoadView.bind(null, false)} />
        </div>
        <div className="App-load">
          <textarea value={this.state.loadFile} onChange={this.onLoadTextChange}></textarea>
          { this.state.loadError ? <div className="App-load-error">{this.state.loadError}</div> : null }
          <div className="App-load-confirm" onClick={this.onLoadConfirm}>
            <i className="icon-round-code" style={{ marginRight: '.6rem' }} />Load
          </div>
        </div>
      </div>
    );

    const modalView = (
      <div className="App-modal" style={{ display: this.state.isModalOpen ? 'initial' : 'none' }} >
        <div className="App-title" style={{ paddingBottom: '1rem' }}>
          <h2>Share options</h2>
          <p>You can test your new pattern with our <a href='https://github.com/FancyPixel/moby' target='_blank' rel='noopener noreferrer'>Moby App</a><br/>or directly in your own app with a single line of code:</p>

          <i className="icon-round-clear App-output-close-icon"onClick={this.toggleModal.bind(null, false)} />
        </div>
        <div className="App-share-permalink-container" style={{ margin: '0 3rem 2rem' }}>
          <input type="text" value={`hapticEngine.playPattern(from: URL(string: "${BackendBasePath}/${this.state.permalink}.json")!)`} onChange={() => {}} readOnly />
          <CopyToClipboard text={`hapticEngine.playPattern(from: URL(string: "${BackendBasePath}/${this.state.permalink}.json")!)`} onCopy={this.onCopy.bind(null, "code")}>
            <span>
              <i className="icon-round-check-circle" style={{ opacity: this.state.copy === "code" ? '1.0' : '0', color: 'white' }} />
              <i className="icon-copy" style={{ opacity: this.state.copy !== "code" ? '1.0' : '0' }} />
            </span>
          </CopyToClipboard>
        </div>

        <div style={{ margin: '1rem auto 0rem', background: 'rgba(0,0,0,0.1)', height: '2px', width: '5rem', borderRadius: '1px' }}></div>

        <div style={{ padding: '0rem 2.5rem', display: 'flex', alignItems: 'center' }}>
          { this.state.permalink ? <div className="App-qrcode-container"><QRCode value={`${BackendBasePath}/${this.state.permalink}.json`} size={140} renderAs="canvas" /></div> : null }
          <div style={{ display: 'flex', flexDirection: 'column', flex: '1 1 100%' }}>
            <span className="App-label" style={{ fontSize: '1rem'}}>Permalink:</span>
            <div className="App-share-permalink-container">
              <input type="text" value={`${BackendBasePath}/${this.state.permalink}`} onChange={() => {}} readOnly />
              <CopyToClipboard text={`${BackendBasePath}/${this.state.permalink}`} onCopy={this.onCopy.bind(null, "permalink")}>
                <span>
                  <i className="icon-round-check-circle" style={{ opacity: this.state.copy === "permalink" ? '1.0' : '0', color: 'white' }} />
                  <i className="icon-copy" style={{ opacity: this.state.copy !== "permalink" ? '1.0' : '0' }} />
                </span>
              </CopyToClipboard>
            </div>

            <span className="App-label" style={{ fontSize: '1rem'}}>JSON Format:</span>
            <div className="App-share-permalink-container">
              <input type="text" value={`${BackendBasePath}/${this.state.permalink}.json`} onChange={() => {}} readOnly />
              <CopyToClipboard text={`${BackendBasePath}/${this.state.permalink}.json`} onCopy={this.onCopy.bind(null, "json")}>
                <span>
                  <i className="icon-round-check-circle" style={{ opacity: this.state.copy === "json" ? '1.0' : '0', color: 'white' }} />
                  <i className="icon-copy" style={{ opacity: this.state.copy !== "json" ? '1.0' : '0' }} />
                </span>
              </CopyToClipboard>
            </div>
          </div>
        </div>
      </div>
    );

    return (
      <div className="App">
        <div className="header" style={{ backgroundImage: `url('${require('./images/home_page.png')}')` }}>
          <img src={require('./images/logo.svg')} alt="logo" />
          <div className="App-info">
            <span>
              Apple introduced in iOS 13 the ability to design your own haptic experiences using the new AHAP file.<br /> This tool provides a quick and easy way to graphically design your own patterns.
            </span>
            <div style={{ display: 'flex', marginTop: '5rem' }}>
              <a href="https://developer.apple.com/documentation/corehaptics/representing_haptic_patterns_in_ahap_files" target="_blank" rel="noopener noreferrer" className="App-share-button" style={{ marginRight: '1rem', height: '2.5rem', minWidth: '10rem' }}>CoreHaptics Docs</a>
              <a href="https://github.com/FancyPixel/moby" target="_blank" rel="noopener noreferrer" className="App-share-button" style={{ marginLeft: '1rem', height: '2.5rem', minWidth: '10rem' }}>Moby App</a>
            </div>
          </div>
          <div className="App-scroll-down" onClick={this.scrollToContent}><i className="icon-round-arrow-downward" /></div>
          <span className="fancypixel-copyright" style={{ position: 'absolute', top: '2rem', left: '50%', transform: 'translate(-50%, 0)'}}>
            <a href="https://www.fancypixel.it/" target="_blank" rel="noopener noreferrer"><i className="icon-logo" /> FANCY PIXEL <span style={{ color: 'rgba(255,255,255,0.3)' }}>PROJECTS</span></a>
          </span>
        </div>
        <div className="content" id="content">
          <div className="App-stage">
            <div className="App-small-logo">
              <img src={require('./images/logo.svg')} alt="small logo" />
            </div>
            <div className="App-hint">
              { this.hintForCurrentState() }
            </div>
            { !this.state.fetching ? (
              <Stage width={screen.width - 30} height={StageHeight} onMouseMove={this.onMouseMove} onMouseUp={() => this.setState({ selected: null })} ref={(e) => { this.stage = e; }}>
                <Layer>
                  <Plot
                    x={0}
                    y={0}
                    screen={screen}
                    padding={PlotPadding * 2}
                    height={PlotHeight}
                    duration={duration}
                    pattern={data.Pattern}
                    parameter={Intensity}
                    mouse={mouse}
                    continuousSelection={this.state.continuousSelection}
                    selected={this.state.selected}
                    showTransient={this.state.showTransient}
                    showContinuous={this.state.showContinuous}
                    onMouseDown={this.onMouseDown}
                    onMouseUp={this.onMouseUp}
                    onMouseMove={this.onNewItemMove}
                    onMouseLeave={this.onMouseLeave}
                    onNewTransient={this.onNewTransient}
                    onDeleteEvent={this.onDeleteEvent}
                    state={plotState}
                  />
                  <Plot
                    x={0}
                    y={PlotHeight}
                    screen={screen}
                    padding={PlotPadding * 2}
                    height={PlotHeight}
                    duration={duration}
                    pattern={data.Pattern}
                    parameter={Sharpness}
                    mouse={mouse}
                    continuousSelection={this.state.continuousSelection}
                    selected={this.state.selected}
                    showTransient={this.state.showTransient}
                    showContinuous={this.state.showContinuous}
                    onMouseDown={this.onMouseDown}
                    onMouseUp={this.onMouseUp}
                    onMouseMove={this.onNewItemMove}
                    onMouseLeave={this.onMouseLeave}
                    onNewTransient={this.onNewTransient}
                    onDeleteEvent={this.onDeleteEvent}
                    state={plotState} />
                </Layer>
              </Stage>
            ) : (
              <div className="App-fetching-loader">
                <Spinner fancy size={35} absolute />
              </div>
            )}

            <div className="App-stage-footer">
              <div className="App-toggles">
                <span className={`App-toggles--transient ${this.state.showTransient ? 'App-toggles--enabled' : ''}`} onClick={() => this.setState({ showTransient: !this.state.showTransient })}><figcaption />Transient</span>
                <span className={`App-toggles--continuous ${this.state.showContinuous ? 'App-toggles--enabled' : ''}`} onClick={() => this.setState({ showContinuous: !this.state.showContinuous })}><figcaption />Continuous</span>
              </div>
              <div className="App-slider-container">
                <span className="App-label">Duration</span>
                <span>0s</span>
                <input className="App-slider" type="range" min="0.1" max="30.0" value={duration} onChange={this.onDurationChange} step={0.1} />
                <span>30s</span>
              </div>
            </div>

            <div className="App-controls">
              <div className={`App-control ${plotState === State.NEW ? 'App-control--enabled' : ''}`} onClick={() => this.setState({ plotState: State.NEW })}><i className="icon-round-add-circle-outline" style={{ fontSize: '1.1rem' }} /></div>
              <div className={`App-control ${plotState === State.EDIT ? 'App-control--enabled' : ''}`} onClick={() => this.setState({ plotState: State.EDIT })}><i className="icon-format-shapes" style={{ fontSize: '.9rem' }} /></div>
              <div className={`App-control ${plotState === State.DELETE ? 'App-control--enabled' : ''}`} onClick={() => this.setState({ plotState: State.DELETE })}><i className="icon-round-delete" style={{ fontSize: '1.1rem' }} /></div>
            </div>

            <div className="App-show-code" onClick={this.toggleCodeView.bind(null, true)}>
              <i className="icon-round-code" style={{ marginRight: '.6rem' }} />Code
            </div>
            <div className="App-load-code" onClick={this.toggleLoadView.bind(null, true)}>
              <i className="icon-round-code" style={{ marginRight: '.6rem' }} />Load from JSON
            </div>
            <div className="App-menu">
              { this.state.permalink ? (
                  <div className="App-cloud-info">
                    { this.state.saving ?
                        <Spinner darkBackground size={20} fancy small />
                      :
                        (
                          <span>
                            Automatically synchronized<br/>
                            { this.state.lastUpdate ? this.state.lastUpdate.fromNow() : moment().fromNow() }
                          </span>
                        )
                    }
                  </div>
                ) : (
                  <div className="App-cloud-info">
                    <span>Save this configuration to get the permalink<br/>and share the json file to our <a href='https://github.com/FancyPixel/moby' target='_blank' rel='noopener noreferrer'>App</a></span>
                  </div>
                )
            }
              <div className="App-share">
                { this.state.permalink ? (
                  <span className="App-share-button" onClick={this.toggleModal.bind(null, true)}>Share Options</span>
                ) : (
                  <span className="App-share-button" onClick={this.onSave.bind(null, true)}>{ this.state.saving ? <Spinner darkBackground size={20} fancy small /> : "Save and Share" }</span>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="footer">
          <ul>
            <li><a href='https://github.com/FancyPixel/moby' target='_blank' rel='noopener noreferrer'>Moby App</a></li>
            <li><a href='https://developer.apple.com/documentation/corehaptics/representing_haptic_patterns_in_ahap_files' target='_blank' rel='noopener noreferrer'>Documentation</a></li>
            <li><a href='https://github.com/FancyPixel/moby/issues' target='_blank' rel='noopener noreferrer'>Feedback</a></li>
          </ul>
          <span className="fancypixel-copyright">
            <a href="https://www.fancypixel.it/" target="_blank" rel="noopener noreferrer"><i className="icon-logo" /> FANCY PIXEL <span style={{ color: 'rgba(255,255,255,0.3)' }}>PROJECTS</span></a>
          </span>
        </div>


        <div className="App-overlay" onClick={() => { this.toggleModal(false); this.toggleCodeView(false); }} style={{ display: this.state.isModalOpen || this.state.isCodeViewVisibile || this.isLoadModalOpen ? 'flex' : 'none' }} />

        { modalView }

        { outputCodeView }

        { loadView }

        <div className="App-mobile-alert" style={{ backgroundImage: `url('${require('./images/home_page.png')}')` }}>
          <img src={require('./images/logo.svg')} alt="Logo" className="App-mobile-logo" />
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <img src={require('./images/mobile_off.svg')} alt="Not mobile friendly" className="App-mobile-error-icon" />
            <h1>Arghh!!</h1>
            <h2>Moby ate our developers before they made this responsive.</h2>
            <h3>Please use a desktop device</h3>
          </div>
          <span className="fancypixel-copyright" style={{ marginBottom: '4rem', fontSize: '1.5rem' }}>
            <a href="https://www.fancypixel.it/" target="_blank" rel="noopener noreferrer"><i className="icon-logo" /> FANCY PIXEL <span style={{ color: 'rgba(255,255,255,0.3)' }}>PROJECTS</span></a>
          </span>
        </div>
      </div>
    );
  }
}

/*
  x: plot's X position
  y: plot's Y position
  screen: whole screen dimensions
  padding: padding relative to x and y
  duration: haptic duration in seconds
  pattern: the data
  parameter: either intensity or sharpness
  mouse: mouse coorinates reltive to the canvas
  state: the editing state
  selected: the selected event
  continuousSelection: determines if a new continous event is being dragged
  showTransient: the plot filter (to hide a certain type of event)
  showContinuous: the plot filter (to hide a certain type of event)
  onMouseDown: handle the mouse down event
  onMouseUp: handle the mouse up event
  onMouseLeave: handle the mouse leave event
  onMouseMove: handle the mouse move event
  onNewTransient: handle the click to insert a new transient
  onDeleteEvent: handle the event deletion
*/
const Plot = ({ x, y, screen, padding, height, duration, pattern, parameter, mouse, state, showContinuous, selected, showTransient, continuousSelection, onMouseDown, onMouseUp, onMouseLeave, onMouseMove, onNewTransient, onDeleteEvent }) => {
  const plotXOffset = 15;
  const axisWidth = screen.width - (padding * 2) - (plotXOffset * 2) - 10;
  const axisHeight = height - (padding * 2);
  const textMarginTop = 10;
  const plotYOffset = parameter === Sharpness ? height : 0;

  // New Transient data
  const hoverValue = -(mouse.y - plotYOffset - axisHeight - padding);
  const hoverTime = x + padding + mouse.x - padding;

  return (
    <Group onMouseMove={onMouseMove.bind(null, { time: (hoverTime - padding) / axisWidth, value: hoverValue / axisHeight })} onMouseUp={onMouseUp.bind(null, { time: (hoverTime - padding) / axisWidth, value: hoverValue / axisHeight })}>
      {/* Capture move and leave events */}
      <Rect x={x + padding} y={y + padding} width={axisWidth} height={axisHeight} fill="#00000000" />

      {/* Plot lines */}
      <Line x={x + padding} y={y + padding + 1} points={[0, axisHeight, axisWidth, axisHeight]} stroke="#FFFFFF"  />

      {/* Axis Text */}
      {
        [...Array(9).keys()].reverse().map((i) => {
          const offset = (axisWidth / 8) * i;
          let centerOffset = 0;
          if (i > 0) {
            centerOffset = 10;
          }
          if (i === 8) {
            centerOffset = 20;
          }
          const value = (duration / 8) *  i;

          return ((i & 1) === 0) ? <Text x={x + padding + offset - centerOffset} y={y + height - padding + textMarginTop} fontFamily="sans-serif" text={`${value.toFixed(2).toString()}s`} fontSize={12} fill="white" key={`text-${i}`} /> : null;
        })
      }

      <Text x={x + padding / 2} y={y + height - padding - textMarginTop} fontFamily="sans-serif" text="0" fontSize={12} fill="#999" />
      <Text x={x + padding / 2} y={y + height - padding - textMarginTop - axisHeight} fontFamily="sans-serif" text="1" fontSize={12} fill="#999" />

      <Text x={x + padding / 2} y={y + height} fontFamily="sans-serif" fontStyle="bold" text={parameter === Intensity ? "Intensity" : "Sharpness"} fontSize={15} fill="#aaa" />

      {/* Events */}
      {
        pattern.map((e, idx) => {
          const px = (e.Event.Time / duration) * axisWidth;
          const item = e.Event.EventParameters.filter(p => p.ParameterID === parameter)[0];
          if (!item) { return null; }
          const h = item.ParameterValue * axisHeight;

          let clickHandler = null;
          if (state === State.DELETE) {
            clickHandler = onDeleteEvent.bind(null, idx);
          }

          if (e.Event.EventType === Continuous && showContinuous) {
            const w = (e.Event.EventDuration / duration) * axisWidth;

            return (
              parameter === Intensity
              ? (
                <Group key={`${parameter}-${idx}`}>
                  <Rect x={x + padding + px} y={y + padding + axisHeight} width={w} height={-h} fill="#E59E6F" onClick={clickHandler} />
                  <Rect x={x + padding + px + w / 2} y={y + padding + axisHeight} width={w / 2} height={-h} fill={state === State.EDIT ? "#E59E6Faa" : "#E59E6Fff"} onClick={clickHandler} />
                  { state === State.EDIT ? <Circle x={x + padding + px} y={y + padding + axisHeight - h} radius={selected === idx ? 7 : 5} fill="white" onMouseDown={state === State.EDIT ? onMouseDown.bind(null, { index: idx, type: parameter, direction: 'left'}) : null} /> : null }
                  { state === State.EDIT ? <Circle x={x + padding + px + w} y={y + padding + axisHeight - h} radius={selected === idx ? 7 : 5} fill="white" onMouseDown={state === State.EDIT ? onMouseDown.bind(null, { index: idx, type: parameter, direction: 'right'}) : null} /> : null }
                </Group>
              ) : (
                <Group key={`${parameter}-${idx}`}>
                  { /* The transparent rect receives the taps */ }
                  <Rect x={x + padding + px} y={y + padding + axisHeight} width={w / 2} height={-h} fill="#00000000" onClick={clickHandler} onMouseDown={state === State.EDIT ? onMouseDown.bind(null, { index: idx, type: parameter, direction: 'left'}) : null} />
                  <Rect x={x + padding + px + w / 2} y={y + padding + axisHeight} width={w / 2} height={-h} fill="#00000000" onClick={clickHandler} onMouseDown={state === State.EDIT ? onMouseDown.bind(null, { index: idx, type: parameter, direction: 'right'}) : null} />
                  <Line x={x + padding + px} y={y + padding + axisHeight} points={[0, 0, 0, -h]} stroke="#E59E6F" />
                  <Line x={x + padding + px} y={y + padding + axisHeight} points={[0, -h, w, -h]} stroke="#E59E6F" />
                  <Line x={x + padding + px} y={y + padding + axisHeight} points={[w, -h, w, 0]} stroke="#E59E6F" />
                  { state === State.EDIT ? <Circle x={x + padding + px} y={y + padding + axisHeight - h} radius={selected === idx ? 7 : 5} fill="white" onMouseDown={state === State.EDIT ? onMouseDown.bind(null, { index: idx, type: parameter, direction: 'left'}) : null} /> : null }
                  { state === State.EDIT ? <Circle x={x + padding + px + w} y={y + padding + axisHeight - h} radius={selected === idx ? 7 : 5} fill="white" onMouseDown={state === State.EDIT ? onMouseDown.bind(null, { index: idx, type: parameter, direction: 'right'}) : null} /> : null }
                </Group>
              )
            );
          } else if (e.Event.EventType === Transient && showTransient) {
            return (
              parameter === Intensity
              ? <Rect x={x + padding + px} y={y + padding + axisHeight} width={TransientWidth} height={-h} fill="#99CEEA" key={`${parameter}-${idx}`} onClick={clickHandler} onMouseDown={state === State.EDIT ? onMouseDown.bind(null, { index: idx, type: parameter }) : null} />
              : (
                <Group key={`${parameter}-${idx}`}>
                  { /* The transparent rect receives the taps */ }
                  <Rect x={x + padding + px} y={y + padding + axisHeight} width={TransientWidth} height={-h} fill="#00000000" onClick={clickHandler} onMouseDown={state === State.EDIT ? onMouseDown.bind(null, { index: idx, type: parameter }) : null} />
                  <Line x={x + padding + px} y={y + padding + axisHeight} points={[0, 0, 0, -h]} stroke="#99CEEA" />
                  <Line x={x + padding + px} y={y + padding + axisHeight} points={[0, -h, TransientWidth, -h]} stroke="#99CEEA" />
                </Group>
              )
            );
          }
          return null;
        })
      }

      {/* Ghost for a new event */}
      {
        (state === State.NEW && mouse.x > padding && mouse.x < (screen.width - padding - (plotXOffset * 2) - 10 - TransientWidth) && mouse.y > (plotYOffset + padding) && mouse.y < (plotYOffset + height - padding))
        ? (
          <Group>
            <Rect
              x={(continuousSelection && continuousSelection.show) ? x + padding + continuousSelection.time * axisWidth : hoverTime}
              y={y + padding + axisHeight}
              width={(continuousSelection && continuousSelection.show) ? continuousSelection.duration * axisWidth : TransientWidth}
              height={-hoverValue}
              fill={(continuousSelection && continuousSelection.show) ? "#E59E6F77" : "#ffffff77"}
              key={`${parameter}-ghost`}
              onClick={state === State.NEW ? onNewTransient.bind(null, { time: (hoverTime - padding) / axisWidth, value: hoverValue / axisHeight }) : null}
              onMouseDown={onMouseDown.bind(null, { time: (hoverTime - padding) / axisWidth, value: hoverValue / axisHeight })}
            />
            <Text x={hoverTime - 10} y={y + height - padding + textMarginTop} fontFamily="sans-serif" text={((hoverTime - padding) / axisWidth * duration).toFixed(2).toString()} fontSize={12} fill="#999" key={`text-ghost`} />
          </Group>
        ) : null
      }

      {/* Plot lines */}
      <Line x={x + padding} y={y + padding + 1} points={[0, 0, 0, axisHeight]} stroke="#28292C" />
      <Line x={x + padding} y={y + padding + 1} points={[0, 0, axisWidth, 0]} stroke="#28292C" width={0.5} />
      <Line x={x + padding} y={y + padding + 1} points={[axisWidth, 0, axisWidth, axisHeight]} stroke="#28292C" width={0.5} />

      {/* Axis Notches */}
      {
        [...Array(9).keys()].reverse().map((i) => {
          const offset = (axisWidth / 8) * i;

          return <Line x={x + padding + offset} y={y + height - padding + 1} points={[0, -3, 0, 3]} stroke="#FFFFFF" key={`notch-${i}`} />;
        })
      }

      <Rect x={padding + axisWidth + 1} y={y + padding} width={padding} height={axisHeight} fill="#1E1F22" />
    </Group>
  );
}

export default App;
